import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import type { CSSProperties } from "react";

import { useCustomSidebarBorderColor } from "../SidebarV2/hooks";
import {
  SIDEBAR_COMPASS_BADGE_THEME_VARS,
  SIDEBAR_COMPASS_THEME_VARS,
} from "./constants";

export const useSidebarCompassThemeVars = (): CSSProperties => {
  const isCustomColorTheme = useIsCustomColorTheme();
  const borderColor = useCustomSidebarBorderColor();

  // Default theme opts out of community branding, but keeps the
  // unread-counter tokens so it still matches the header's badge.
  if (!isCustomColorTheme) {
    return SIDEBAR_COMPASS_BADGE_THEME_VARS;
  }

  return {
    ...SIDEBAR_COMPASS_THEME_VARS,
    ["--color-community-sidebar-border" as string]: borderColor,
    backgroundColor: "var(--color-community-sidebar-background)",
  };
};
